export function getAmplitudeToken(): string {
  return import.meta.env.VITE_AMPLITUDE_TOKEN;
}
